import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import UpdateDocument from '@/components/disposable/UpdateDocument.vue';
import { DocumentType } from '@/model/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateOnlyfansView',
  setup(__props) {

const route = useRoute();
const actorID = route.params.actorID as string;
const documentUUID = route.params.documentUUID as string;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UpdateDocument, {
    "document-type": _unref(DocumentType).Onlyfans,
    metadataID: _unref(actorID),
    documentUUID: _unref(documentUUID)
  }, null, 8, ["document-type", "metadataID", "documentUUID"]))
}
}

})